type ServicePrefix = "api" | "ws";

declare const __REVIEW_BRANCH__: string;
const REVIEW_BRANCH = typeof __REVIEW_BRANCH__ !== 'undefined' ? __REVIEW_BRANCH__ : '';
if (REVIEW_BRANCH) {
  console.log(`[Review Environment] Branch: ${REVIEW_BRANCH}, Backend: ${REVIEW_BRANCH}.api.myfindex.dev`);
}

const getServiceUrl = (prefix: ServicePrefix): string => {
  const hostname = window.location.hostname;
  const protocol = prefix === "ws" ? "wss" : "https";
  const localProtocol = prefix === "ws" ? "ws" : "http";

  // Local development: each worktree shifts ports by the same offset, so a
  // FE on 808N talks to API 300N / WS 1011N.
  if (hostname === "localhost") {
    const offset = (Number(window.location.port) || 8081) - 8081;
    const port = (prefix === "ws" ? 10111 : 3000) + offset;
    return `${localProtocol}://localhost:${port}`;
  }

  // Review app (Amplify PR preview) → branch-specific backend
  if (hostname.includes('amplifyapp.com') && REVIEW_BRANCH && REVIEW_BRANCH !== 'master') {
    return `${protocol}://${REVIEW_BRANCH}.${prefix}.myfindex.dev`;
  }

  // Stage environment
  if (hostname.indexOf("stage.app.myfindex") !== -1) {
    return hostname.indexOf(".dev") !== -1
      ? `${protocol}://stage.${prefix}.myfindex.dev`
      : `${protocol}://stage.${prefix}.myfindex.com`;
  }

  // Production environment
  if (hostname.indexOf("app.myfindex") !== -1) {
    return (hostname.indexOf(".dev") !== -1 || hostname.includes('amplify'))
      ? `${protocol}://${prefix}.myfindex.dev`
      : `${protocol}://${prefix}.myfindex.com`;
  }

  // Any other amplify domain (no branch set) → dev backend
  if (hostname.includes('amplify')) {
    return `${protocol}://${prefix}.myfindex.dev`;
  }

  // Default production
  return `${protocol}://${prefix}.myfindex.com`;
};

export const env = {
  VITE_APP_SERVICE_IR: getServiceUrl("api"),
  VITE_APP_WEBSOCKET_URL: getServiceUrl("ws"),
  VITE_APP_IR_AUDIENCE: getServiceUrl("api"),
  VITE_APP_BASE_URL: "https://localhost:8081",
  VITE_APP_POSTHOG_HOST: "https://eu.i.posthog.com",
  VITE_APP_LOGO_PUBLIC_KEY: 'pk_YynzE9gsRxCYdOnzaQYqug' // this is a public key and it's fine to share
};
